// Conversa (0.35): mensagens em tempo real, fotos, arquivos, responder, apagar para todos e chamadas.
import { useEffect, useMemo, useRef, useState } from 'react';
import { abrirUrlComApp } from '../lib/abrirArquivo';
import { nomeAnexo } from '../lib/nomeArquivo';
import { ActivityIndicator, Alert, Animated, BackHandler, FlatList, Image, Keyboard, KeyboardAvoidingView, Linking, PanResponder, Platform, Pressable, Text, TextInput, View } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTecladoAndroid } from '../components/teclado';
import {
  aberta, apagarMensagem, arquivar, conversaCom, carregarMensagens, encaminhar, enviarArquivo, enviarTexto, marcarLida, membrosDa, resumoDe, sairDoGrupo, silenciar, urlDoAnexo, useChat, type Mensagem,
} from '../lib/chat';
import { abrirChamada } from '../lib/chamada';
import { lerBase64 } from '../lib/anexos';
import { useAnexar } from '../components/MenuAnexo';
import { Avatar, CartaoContato } from '../components/Contato';
import { VerFoto } from '../components/VerFoto';
import { CoresChatSheet } from '../components/CoresChat';
import { useDenunciar } from '../components/Denunciar';
import { useCoresChat } from '../lib/coresChat';
import { semBloqueio } from '../auth/AuthContext';
import { ActionSheet, Sheet, type Action } from '../components/ui';
import { C, alpha, useCores } from '../components/theme';
import { brYmd, hm, today } from '../lib/date';
import { t } from '../lib/i18n';
import { PainelExpressao } from '../components/PainelExpressao';
import { FigurinhaView } from '../components/Figurinha';
import { guardarFigurinha, guardarGif } from '../lib/figurinhas';
export { ErrorBoundary } from '../components/Falha';

const bytesDe = (b64: string) => {
  const bin = atob(b64); const u = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
  return u;
};
const hora = (iso: string) => hm(new Date(iso));
const dia = (iso: string) => { const d = new Date(iso); const s = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; return s; };

function Foto({ path, onPress }: { path: string; onPress: (url: string) => void }) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => { urlDoAnexo(path).then(setUrl); }, [path]);
  if (!url) return <View style={{ width: 200, height: 150, borderRadius: 12, backgroundColor: 'rgba(0,0,0,0.2)', alignItems: 'center', justifyContent: 'center' }}><ActivityIndicator color="#fff" /></View>;
  return <Pressable onPress={() => onPress(url)}><Image source={{ uri: url }} style={{ width: 220, height: 220, borderRadius: 12 }} resizeMode="cover" /></Pressable>;
}


/** Puxar a mensagem para a direita responde a ela (como no WhatsApp). */
function PuxarParaResponder({ children, onResponder, desligado, cor }: { children: React.ReactNode; onResponder: () => void; desligado?: boolean; cor: string }) {
  const x = useRef(new Animated.Value(0)).current;
  const passou = useRef(false);
  const LIMITE = 64;
  const pan = useRef(PanResponder.create({
    onMoveShouldSetPanResponder: (_e, g) => !desligado && g.dx > 12 && Math.abs(g.dx) > Math.abs(g.dy) * 2,
    onMoveShouldSetPanResponderCapture: (_e, g) => !desligado && g.dx > 14 && Math.abs(g.dx) > Math.abs(g.dy) * 2.5,
    onPanResponderTerminationRequest: () => false,
    onPanResponderGrant: () => { passou.current = false; },
    onPanResponderMove: (_e, g) => {
      const d = Math.max(0, Math.min(g.dx, 110));
      x.setValue(d);
      if (d >= LIMITE && !passou.current) { passou.current = true; vibrar(); }
      if (d < LIMITE) passou.current = false;
    },
    onPanResponderRelease: () => {
      if (passou.current) onResponderRef.current();
      Animated.spring(x, { toValue: 0, useNativeDriver: Platform.OS !== 'web', bounciness: 6 }).start();
    },
    onPanResponderTerminate: () => Animated.spring(x, { toValue: 0, useNativeDriver: Platform.OS !== 'web' }).start(),
  })).current;
  const onResponderRef = useRef(onResponder);
  onResponderRef.current = onResponder;
  const icone = x.interpolate({ inputRange: [0, LIMITE], outputRange: [0, 1], extrapolate: 'clamp' });
  // navegador: o mouse usa os eventos de ponteiro (o PanResponder não pega o arraste do mouse sobre texto)
  const ini = useRef<{ x: number; y: number; ativo: boolean } | null>(null);
  const web = Platform.OS === 'web' && !desligado ? {
    onPointerDown: (e: any) => { ini.current = { x: e.clientX, y: e.clientY, ativo: false }; passou.current = false; },
    onPointerMove: (e: any) => {
      const c = ini.current; if (!c) return;
      const dx = e.clientX - c.x, dy = e.clientY - c.y;
      if (!c.ativo) { if (dx > 12 && Math.abs(dx) > Math.abs(dy) * 2) { c.ativo = true; try { window.getSelection()?.removeAllRanges(); document.body.style.userSelect = 'none'; } catch { /* segue */ } } else if (Math.abs(dy) > 12) { ini.current = null; } return; }
      const d = Math.max(0, Math.min(dx, 110)); x.setValue(d); passou.current = d >= LIMITE;
    },
    onPointerUp: () => {
      const c = ini.current; ini.current = null;
      try { document.body.style.userSelect = ''; } catch { /* segue */ }
      if (c?.ativo) { if (passou.current) onResponderRef.current(); Animated.spring(x, { toValue: 0, useNativeDriver: false, bounciness: 6 }).start(); }
    },
  } : {};
  return (
    <View>
      <Animated.View pointerEvents="none" style={{ position: 'absolute', left: 4, top: 0, bottom: 0, justifyContent: 'center', opacity: icone, transform: [{ scale: icone }] }}>
        <View style={{ width: 32, height: 32, borderRadius: 16, backgroundColor: cor, alignItems: 'center', justifyContent: 'center' }}><Text style={{ color: '#fff', fontSize: 16 }}>↩</Text></View>
      </Animated.View>
      <Animated.View {...(Platform.OS === 'web' ? web : pan.panHandlers)} style={{ transform: [{ translateX: x }] }}>{children}</Animated.View>
    </View>
  );
}
const vibrar = () => { try { require('expo-haptics').impactAsync?.(require('expo-haptics').ImpactFeedbackStyle?.Light); } catch { /* sem vibração */ } };

export default function TelaConversa() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const router = useRouter();
  const ins = useSafeAreaInsets();
  const teclado = useTecladoAndroid();
  const { accent } = useCores();
  const chat = useChat();
  const conv = chat.conversas?.find(c => c.id === id);
  const msgs = chat.msgs[id ?? ''] ?? null;
  const [texto, setTexto] = useState('');
  const [resp, setResp] = useState<Mensagem | null>(null);
  const [menu, setMenu] = useState<{ t: string; a: Action[] } | null>(null);
  const [mais, setMais] = useState(false);
  const [verFoto, setVerFoto] = useState<string | null>(null);
  const [membros, setMembros] = useState<{ user_id: string; nome: string; admin: boolean }[] | null>(null);
  const [cartao, setCartao] = useState<{ id: string; nome: string } | null>(null);
  const [cores, setCores] = useState(false);
  const [painel, setPainel] = useState(false);
  const [encaminharMsg, setEncaminharMsg] = useState<Mensagem | null>(null);
  const k = useCoresChat();
  // 0.72 (11g): o mesmo menu de anexos do app (Fotos · Tirar foto · Arquivos); semNuvem: o arquivo vai para a conversa
  const anexo = useAnexar({ cor: accent, semNuvem: true });
  const den = useDenunciar(accent, chat.eu);   // 0.73: 🚩 Denunciar (regra 1.2 da Apple)
  const lista = useRef<FlatList>(null);
  const campo = useRef<TextInput>(null);

  useEffect(() => {
    if (!id) return;
    aberta.id = id;
    carregarMensagens(id).then(setMais);
    marcarLida(id);
    return () => { if (aberta.id === id) aberta.id = null; };
  }, [id]);

  // voltar do Android fecha o painel de emojis antes de sair da conversa
  useEffect(() => {
    if (!painel) return;
    const s = BackHandler.addEventListener('hardwareBackPress', () => { setPainel(false); return true; });
    return () => s.remove();
  }, [painel]);

  const itens = useMemo(() => [...(msgs ?? [])].reverse(), [msgs]);
  const porId = useMemo(() => new Map((msgs ?? []).map(m => [m.id, m])), [msgs]);
  const grupo = conv?.tipo === 'grupo';

  const enviar = () => { if (!id || !texto.trim()) return; enviarTexto(id, texto, resp?.id); setTexto(''); setResp(null); };
  const anexar = async () => {
    if (!id) return;
    try {
      const r = await anexo.anexar({ tipo: 'tudo', titulo: t('Enviar') });
      const a = r?.anexo;
      if (!a) return;
      const b64 = await lerBase64(a);
      if (!b64) throw new Error(t('Não foi possível ler o arquivo.'));
      await enviarArquivo(id, { bytes: bytesDe(b64), mime: a.mime || 'application/octet-stream', nome: a.nome });
    } catch (e: any) { Alert.alert(t('Não foi possível enviar'), String(e?.message ?? e)); }
  };
  const abrirArquivo = async (m: Mensagem) => {
    const u = m.anexo ? await urlDoAnexo(m.anexo.path) : null;
    if (u) semBloqueio(() => abrirUrlComApp(u, m.anexo!.mime, nomeAnexo(m.anexo!))).catch(() => {});
  };
  const opcoes = (m: Mensagem) => {
    if (m.apagada || m.tipo === 'sistema' || m.enviando) return;
    const a: Action[] = [{ label: '↩ ' + t('Responder'), onPress: () => setResp(m) }];
    if (m.tipo === 'figurinha' && m.anexo?.fig) a.push({ label: '⭐ ' + t('Guardar nas minhas figurinhas'), onPress: () => { guardarFigurinha(m.anexo!.fig!); Alert.alert('⭐', t('Guardada nas suas figurinhas.')); } });
    if (m.tipo === 'gif' && m.anexo?.url) a.push({ label: '⭐ ' + t('Guardar nos meus GIFs'), onPress: () => { guardarGif({ url: m.anexo!.url!, w: m.anexo!.w ?? 200, h: m.anexo!.h ?? 200 }); Alert.alert('⭐', t('GIF guardado nos seus GIFs.')); } });
    if (m.tipo !== 'chamada') a.push({ label: '↪ ' + t('Encaminhar'), onPress: () => setEncaminharMsg(m) });
    if (m.autor === chat.eu) a.push({ label: '🗑 ' + t('Apagar para todos'), destructive: true, onPress: () => Alert.alert(t('Apagar para todos?'), m.tipo === 'texto' ? m.texto.slice(0, 120) : resumoDe(m), [
      { text: t('Cancelar'), style: 'cancel' }, { text: t('Apagar'), style: 'destructive', onPress: () => apagarMensagem(m) }]) });
    if (m.autor !== chat.eu) a.push({ label: '🚩 ' + t('Denunciar'), destructive: true, onPress: () => den.abrir({ mensagem: m, usuario: m.autor, nome: m.autor_nome, conversa: m.conversa_id }) });
    setMenu({ t: m.tipo === 'texto' ? m.texto.slice(0, 60) : resumoDe(m), a });
  };
  const opConversa = () => {
    if (!conv) return;
    const a: Action[] = [{ label: conv.silenciada ? '🔔 ' + t('Ativar avisos') : '🔕 ' + t('Silenciar avisos'), onPress: () => silenciar(conv.id, !conv.silenciada) }];
    if (grupo) a.push({ label: '👥 ' + t('Ver participantes'), onPress: () => membrosDa(conv.id).then(setMembros) });
    a.push({ label: conv.arquivada ? '📤 ' + t('Desarquivar') : '📦 ' + t('Arquivar conversa'), onPress: () => arquivar(conv.id, !conv.arquivada).then(() => { if (!conv.arquivada) router.back(); }).catch(e => Alert.alert(String(e?.message ?? e))) });
    a.push({ label: '🎨 ' + t('Cores das conversas'), onPress: () => setCores(true) });
    a.push({ label: '🚩 ' + (grupo ? t('Denunciar grupo') : t('Denunciar contato')), destructive: true,
      onPress: () => den.abrir(grupo ? { grupo: true, nome: conv.nome, conversa: conv.id } : { usuario: conv.outro, nome: conv.nome, conversa: conv.id }) });
    if (grupo && !conv.grupo_id) a.push({ label: t('Sair do grupo'), destructive: true, onPress: () => Alert.alert(t('Sair do grupo?'), conv.nome, [
      { text: t('Cancelar'), style: 'cancel' }, { text: t('Sair'), style: 'destructive', onPress: () => sairDoGrupo(conv.id).then(() => router.back()).catch(e => Alert.alert(String(e.message))) }]) });
    setMenu({ t: conv.nome, a });
  };
  const ligar = (tipo: 'audio' | 'video') => conv && abrirChamada(conv.id, tipo, conv.nome);
  // toque no nome: a dois, abre o cartão de contato; em grupo, os participantes
  const verCartao = () => { if (!conv) return; if (grupo) membrosDa(conv.id).then(setMembros); else if (conv.outro) setCartao({ id: conv.outro, nome: conv.nome }); };

  const bolha = ({ item: m, index }: { item: Mensagem; index: number }) => {
    const meu = m.autor === chat.eu;
    const anterior = itens[index + 1];
    const novoDia = !anterior || dia(anterior.criado_em) !== dia(m.criado_em);
    const separador = novoDia ? (
      <Text style={{ alignSelf: 'center', color: C.sub, fontSize: 11, backgroundColor: C.card, paddingHorizontal: 10, paddingVertical: 3, borderRadius: 10, marginVertical: 8 }}>
        {dia(m.criado_em) === today() ? t('Hoje') : brYmd(dia(m.criado_em))}</Text>) : null;
    if (m.tipo === 'sistema') return <View>{separador}<Text style={{ alignSelf: 'center', color: C.sub, fontSize: 12, marginVertical: 4 }}>{m.autor_nome} {t(m.texto)}</Text></View>;
    if (m.tipo === 'chamada') {
      const recente = Date.now() - new Date(m.criado_em).getTime() < 3 * 3600000;
      return (
        <View>{separador}
          <View style={{ alignSelf: 'center', alignItems: 'center', gap: 6, backgroundColor: C.card, borderRadius: 14, padding: 10, marginVertical: 4, minWidth: 220 }}>
            <Text style={{ color: C.text }}>{m.anexo?.midia === 'audio' ? '📞' : '🎥'} {meu ? t('Você ligou') : t('{nome} ligou', { nome: m.autor_nome })} · {hora(m.criado_em)}</Text>
            {recente && <Pressable onPress={() => ligar(m.anexo?.midia === 'audio' ? 'audio' : 'video')} style={{ backgroundColor: C.ok, borderRadius: 10, paddingHorizontal: 14, paddingVertical: 6 }}>
              <Text style={{ color: '#fff', fontWeight: '700' }}>{t('Entrar na chamada')}</Text></Pressable>}
          </View>
        </View>
      );
    }
    const r = m.resposta_a ? porId.get(m.resposta_a) : null;
    // figurinha e GIF: sem balão, como no WhatsApp
    if (!m.apagada && (m.tipo === 'figurinha' || m.tipo === 'gif') && m.anexo) {
      const g = m.anexo;
      const w = Math.min(220, g.w ?? 200), h = g.w && g.h ? Math.min(260, (w * g.h) / g.w) : w;
      return (
        <View>{separador}
          <PuxarParaResponder cor={k.enviada} desligado={m.enviando} onResponder={() => { setResp(m); campo.current?.focus(); }}>
            <Pressable onLongPress={() => opcoes(m)} delayLongPress={1000} style={{ alignSelf: meu ? 'flex-end' : 'flex-start', marginVertical: 4, alignItems: meu ? 'flex-end' : 'flex-start', opacity: m.enviando ? 0.6 : 1 }}>
              {grupo && !meu && <Text style={{ color: C.sub, fontSize: 12, fontWeight: '700' }}>{m.autor_nome}</Text>}
              {m.tipo === 'figurinha' && g.fig ? <FigurinhaView f={g.fig} tam={150} />
                : <Image source={{ uri: g.url }} style={{ width: w, height: h, borderRadius: 12, backgroundColor: C.card2 }} resizeMode="cover" />}
              <Text style={{ color: C.mute, fontSize: 10, backgroundColor: alpha(C.bg, 0.6), paddingHorizontal: 6, borderRadius: 8 }}>{hora(m.criado_em)}{meu ? (m.erro ? ' ⚠️' : m.enviando ? ' ⏱' : ' ✓') : ''}</Text>
            </Pressable>
          </PuxarParaResponder>
        </View>
      );
    }
    return (
      <View>{separador}
        <PuxarParaResponder cor={k.enviada} desligado={m.apagada || m.enviando} onResponder={() => { setResp(m); campo.current?.focus(); }}>
        <Pressable onLongPress={() => opcoes(m)} delayLongPress={1000}
          style={{ alignSelf: meu ? 'flex-end' : 'flex-start', maxWidth: '82%', marginVertical: 2, backgroundColor: meu ? k.enviada : k.recebida,
            borderRadius: 16, borderBottomRightRadius: meu ? 4 : 16, borderBottomLeftRadius: meu ? 16 : 4, padding: m.tipo === 'foto' ? 4 : 10, gap: 4, opacity: m.enviando ? 0.7 : 1 }}>
          {grupo && !meu && <Text style={{ color: k.textoRecebida === '#FFFFFF' ? '#C4B5FD' : '#5B21B6', fontSize: 12, fontWeight: '700', paddingHorizontal: m.tipo === 'foto' ? 6 : 0 }}>{m.autor_nome}</Text>}
          {!!r && <View style={{ borderLeftWidth: 3, borderLeftColor: meu ? k.textoEnviada : accent, paddingLeft: 8, opacity: 0.8 }}>
            <Text style={{ color: meu ? k.suaveEnviada : k.suaveRecebida, fontSize: 12 }} numberOfLines={2}>{r.autor_nome}: {r.apagada ? t('Mensagem apagada') : resumoDe(r)}</Text></View>}
          {m.apagada ? <Text style={{ color: meu ? k.suaveEnviada : k.suaveRecebida, fontStyle: 'italic' }}>🚫 {t('Mensagem apagada')}</Text>
            : m.tipo === 'foto' && m.anexo ? (m.enviando ? <View style={{ width: 200, height: 150, alignItems: 'center', justifyContent: 'center' }}><ActivityIndicator color="#fff" /></View> : <Foto path={m.anexo.path} onPress={setVerFoto} />)
            : m.tipo !== 'texto' && m.anexo ? (
              <Pressable onPress={() => abrirArquivo(m)} style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                <Text style={{ fontSize: 26 }}>{m.tipo === 'video' ? '🎬' : m.tipo === 'audio' ? '🎤' : '📎'}</Text>
                <View style={{ flexShrink: 1 }}>
                  <Text style={{ color: meu ? k.textoEnviada : k.textoRecebida, fontWeight: '600' }} numberOfLines={2}>{nomeAnexo(m.anexo)}</Text>
                  {!!m.anexo.tam && <Text style={{ color: meu ? k.suaveEnviada : k.suaveRecebida, fontSize: 11 }}>{Math.max(1, Math.round(m.anexo.tam / 1024))} KB · {t('toque para abrir')}</Text>}
                </View>
              </Pressable>)
            : <Text style={{ color: meu ? k.textoEnviada : k.textoRecebida, fontSize: 15 }} selectable>{m.texto}</Text>}
          <Text style={{ color: meu ? k.suaveEnviada : k.suaveRecebida, fontSize: 10, alignSelf: 'flex-end', paddingHorizontal: m.tipo === 'foto' ? 6 : 0 }}>
            {hora(m.criado_em)}{meu ? (m.erro ? ' ⚠️' : m.enviando ? ' ⏱' : ' ✓') : ''}</Text>
        </Pressable>
        </PuxarParaResponder>
      </View>
    );
  };

  return (
    <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} style={{ flex: 1, backgroundColor: C.bg }}>
      <View style={{ paddingTop: ins.top + 6, paddingHorizontal: 10, paddingBottom: 8, flexDirection: 'row', alignItems: 'center', gap: 8, backgroundColor: C.card, borderBottomWidth: 1, borderBottomColor: C.line }}>
        <Pressable onPress={() => (router.canGoBack() ? router.back() : router.navigate('/mensagens' as any))} hitSlop={12}><Text style={{ color: C.sub, fontSize: 26 }}>‹</Text></Pressable>
        <Pressable onPress={verCartao} style={{ flexDirection: 'row', alignItems: 'center', gap: 8, flex: 1 }}>
        <Avatar id={grupo ? null : conv?.outro} nome={conv?.nome ?? '?'} tam={38} cor={accent} icone={grupo ? (conv?.grupo_id ? '🏫' : '👥') : undefined} />
        <View style={{ flex: 1 }}>
          <Text style={{ color: C.text, fontWeight: '800', fontSize: 16 }} numberOfLines={1}>{conv?.nome ?? t('Conversa')}</Text>
          <Text style={{ color: C.sub, fontSize: 11 }} numberOfLines={1}>{grupo ? t('{n} participantes · toque para ver', { n: conv?.membros ?? 0 }) : conv?.silenciada ? '🔕 ' + t('avisos silenciados') : t('toque para ver o contato')}</Text>
        </View>
        </Pressable>
        <Pressable onPress={() => conv && silenciar(conv.id, !conv.silenciada)} hitSlop={8} style={{ padding: 6 }}
          accessibilityLabel={conv?.silenciada ? t('Ativar avisos') : t('Silenciar avisos')}><Text style={{ fontSize: 20, opacity: conv?.silenciada ? 0.6 : 1 }}>{conv?.silenciada ? '🔕' : '🔔'}</Text></Pressable>
        <Pressable onPress={() => ligar('audio')} hitSlop={8} style={{ padding: 6 }}><Text style={{ fontSize: 20 }}>📞</Text></Pressable>
        <Pressable onPress={() => ligar('video')} hitSlop={8} style={{ padding: 6 }}><Text style={{ fontSize: 20 }}>🎥</Text></Pressable>
        <Pressable onPress={opConversa} hitSlop={8} style={{ padding: 6 }} accessibilityLabel={t('Mais opções')}><Text style={{ color: C.sub, fontSize: 20, fontWeight: '800' }}>⋮</Text></Pressable>
      </View>

      {msgs === null ? <ActivityIndicator style={{ marginTop: 40 }} color={accent} /> : (
        <FlatList ref={lista} inverted data={itens} keyExtractor={m => m.id} renderItem={bolha}
          contentContainerStyle={{ padding: 12, gap: 2 }}
          onEndReached={() => { if (mais && id && msgs.length) carregarMensagens(id, msgs[0].criado_em).then(setMais); }}
          ListFooterComponent={!itens.length ? <Text style={{ color: C.sub, textAlign: 'center', marginVertical: 30 }}>{t('Nenhuma mensagem ainda. Diga oi! 👋')}</Text> : null} />
      )}

      {!!resp && (
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, paddingHorizontal: 12, paddingVertical: 6, backgroundColor: C.card, borderTopWidth: 1, borderTopColor: C.line }}>
          <View style={{ flex: 1, borderLeftWidth: 3, borderLeftColor: accent, paddingLeft: 8 }}>
            <Text style={{ color: accent, fontSize: 12, fontWeight: '700' }}>{t('Respondendo a {nome}', { nome: resp.autor_nome || t('você') })}</Text>
            <Text style={{ color: C.sub, fontSize: 12 }} numberOfLines={1}>{resumoDe(resp)}</Text>
          </View>
          <Pressable onPress={() => setResp(null)} hitSlop={8}><Text style={{ color: C.mute }}>✕</Text></Pressable>
        </View>
      )}
      <View style={{ flexDirection: 'row', alignItems: 'flex-end', gap: 8, paddingHorizontal: 8, paddingTop: 8, paddingBottom: painel ? 8 : ins.bottom + teclado + 8, backgroundColor: C.card }}>
        <Pressable onPress={anexar}
          style={{ width: 42, height: 42, borderRadius: 21, alignItems: 'center', justifyContent: 'center', backgroundColor: C.card2 }}>
          <Text style={{ fontSize: 20, color: C.text }}>＋</Text></Pressable>
        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'flex-end', backgroundColor: C.card2, borderRadius: 20 }}>
        <Pressable onPress={() => { if (painel) { setPainel(false); campo.current?.focus(); } else { Keyboard.dismiss(); setPainel(true); } }} hitSlop={6}
          accessibilityLabel={t('Emojis, GIFs e figurinhas')} style={{ paddingLeft: 10, paddingRight: 2, paddingVertical: 9 }}>
          <Text style={{ fontSize: 20, color: C.sub }}>{painel ? '⌨️' : '😊'}</Text></Pressable>
        <TextInput ref={campo} value={texto} onChangeText={setTexto} placeholder={t('Mensagem')} placeholderTextColor={C.mute} multiline onFocus={() => setPainel(false)}
          style={{ flex: 1, color: C.text, paddingHorizontal: 8, paddingTop: 10, paddingBottom: 10, maxHeight: 120, fontSize: 15 }}
          onKeyPress={(e: any) => { if (Platform.OS === 'web' && e.nativeEvent.key === 'Enter' && !e.nativeEvent.shiftKey) { e.preventDefault?.(); enviar(); } }} />
        </View>
        <Pressable onPress={enviar} disabled={!texto.trim()} style={{ width: 42, height: 42, borderRadius: 21, alignItems: 'center', justifyContent: 'center', backgroundColor: texto.trim() ? accent : C.card2 }}>
          <Text style={{ color: '#fff', fontSize: 18 }}>➤</Text></Pressable>
      </View>
      {painel && !!id && <PainelExpressao conv={id} cor={accent} onEmoji={e => setTexto(x => x + e)} />}
      {anexo.tela}
      <Sheet visible={!!encaminharMsg} onClose={() => setEncaminharMsg(null)} title={t('Encaminhar para')}>
        <FlatList data={(chat.conversas ?? []).filter(c => !c.arquivada)} keyExtractor={c => c.id} contentContainerStyle={{ padding: 16, gap: 6 }}
          renderItem={({ item: c }) => (
            <Pressable onPress={() => { const m = encaminharMsg!; setEncaminharMsg(null); encaminhar(m, c.id).then(() => Alert.alert('↪', t('Encaminhada para {nome}.', { nome: c.nome }))).catch(e => Alert.alert(t('Não foi possível enviar'), String(e?.message ?? e))); }}
              style={{ flexDirection: 'row', alignItems: 'center', gap: 10, backgroundColor: C.card, borderRadius: 12, padding: 10 }}>
              <Avatar id={c.tipo === 'grupo' ? null : c.outro} nome={c.nome} tam={40} cor={accent} icone={c.tipo === 'grupo' ? '👥' : undefined} />
              <Text style={{ color: C.text, flex: 1 }} numberOfLines={1}>{c.nome}</Text>
            </Pressable>
          )} />
      </Sheet>
      <ActionSheet title={menu?.t ?? ''} actions={menu?.a ?? null} onClose={() => setMenu(null)} />
      <Sheet visible={!!membros} onClose={() => setMembros(null)} title={t('Participantes')}>
        <FlatList data={membros ?? []} keyExtractor={m => m.user_id} contentContainerStyle={{ padding: 16, gap: 6 }}
          renderItem={({ item }) => (
            <Pressable onPress={() => { if (item.user_id !== chat.eu) { setMembros(null); setCartao({ id: item.user_id, nome: item.nome }); } }}
              onLongPress={() => { if (item.user_id !== chat.eu) { setMembros(null); setTimeout(() => den.abrir({ usuario: item.user_id, nome: item.nome, conversa: conv?.id }), 300); } }} delayLongPress={400}
              style={{ flexDirection: 'row', alignItems: 'center', gap: 10, backgroundColor: C.card, borderRadius: 12, padding: 10 }}>
              <Avatar id={item.user_id} nome={item.nome} tam={40} cor={accent} />
              <Text style={{ color: C.text, flex: 1 }}>{item.nome}{item.user_id === chat.eu ? ' (' + t('você') + ')' : ''}</Text>
              {item.admin && <Text style={{ color: C.sub, fontSize: 12 }}>{t('administra')}</Text>}
            </Pressable>
          )} />
      </Sheet>
      <CoresChatSheet visible={cores} onClose={() => setCores(false)} />
      <CartaoContato id={cartao?.id ?? null} nome={cartao?.nome ?? ''} cor={accent} onClose={() => setCartao(null)}
        onLigar={!grupo ? (tipo => { setCartao(null); ligar(tipo); }) : undefined}
        onConversar={grupo ? () => { const x = cartao!; setCartao(null); conversaCom(x.id, x.nome).then(nova => router.push({ pathname: '/conversa', params: { id: nova } } as any)).catch(e => Alert.alert(String(e?.message ?? e))); } : undefined} />
            <VerFoto url={verFoto} onClose={() => setVerFoto(null)} />
      {den.janela}
    </KeyboardAvoidingView>
  );
}
